import Typography from '@mui/material/Typography';
import { Breadcrumbs } from '@aeg-presents/components/Breadcrumbs';
import { PageHeader } from '@aeg-presents/components/PageHeader';
import { Table } from '@aeg-presents/components/Table';
import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';
import { RouterLink } from '../components/RouterLink';
import { toursMockData } from '../data/tours';
import { TourNameLink, ToursPageContainer } from './ToursPage.styled';
import { formatDisplayValue } from '@utils/formatters';

type TourTableRow = {
  id: string;
  name: string;
  headliner: string;
};

const columns: GridColDef<TourTableRow>[] = [
  {
    field: 'name',
    headerName: 'Tour',
    flex: 1,
    minWidth: 220,
    renderCell: (params) => (
      <TourNameLink to={`/tours/${params.row.id}`}>
        <Typography data-testid="child-tour-link" variant="body2" color="inherit">
          {params.row.name}
        </Typography>
      </TourNameLink>
    ),
  },
  {
    field: 'headliner',
    headerName: 'Headliner',
    flex: 1,
    minWidth: 220,
  },
];

export function ToursPage() {
  const rows = useMemo<TourTableRow[]>(
    () =>
      toursMockData.map((tour) => ({
        id: tour.id,
        name: tour.name,
        headliner: formatDisplayValue(tour.headliner),
      })),
    [],
  );

  return (
    <ToursPageContainer>
      <Breadcrumbs items={[{ text: 'Tours', href: '/tours' }]} LinkComponent={RouterLink} />
      <PageHeader headerText="Tours" />
      <Table rows={rows} columns={columns} />
    </ToursPageContainer>
  );
}
